import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  LIFECYCLE_GROUP_LABEL,
  LIFECYCLE_LABEL,
  LIFECYCLE_STATES_BY_GROUP,
} from "../lifecycleStates";
import type { LifecycleState } from "../types";

type Props = {
  value: LifecycleState;
  onChange: (next: LifecycleState) => void;
  ariaLabel?: string;
};

const GROUP_ORDER = ["cria", "desarrollo", "productiva", "retirada"] as const;

export function LifecycleStateSelect({ value, onChange, ariaLabel }: Props) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as LifecycleState)}>
      <SelectTrigger className="h-9 w-full text-app-ink-1" aria-label={ariaLabel}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {GROUP_ORDER.map((group) => (
          <SelectGroup key={group}>
            <SelectLabel>{LIFECYCLE_GROUP_LABEL[group]}</SelectLabel>
            {LIFECYCLE_STATES_BY_GROUP[group].map((state) => (
              <SelectItem key={state} value={state}>
                {LIFECYCLE_LABEL[state]}
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
